import React, { useEffect } from 'react';
import { setEditedProfile } from '../../../redux/applicationSlice';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useDispatch, useSelector } from 'react-redux';
import FocusButtons from './FocusButtons';
import ViewingRestrictionItems from './viewingRestrictionItems';

const LanguagePopup = ({
    languages,
    languageSelector,
    setLanguageSelector,
}) => {

    const dispatch = useDispatch();
    const { theme, editedProfile } = useSelector((state) => state.application);

    const { ref, focused, setFocus, focusSelf } = useFocusable({
        focusKey: "LanguagePopup",
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            return true;
        },
        onEnterRelease: () => { },
    });

    useEffect(() => {
        if (languageSelector) {
            focusSelf();
        }
    }, [languageSelector]);

    return (
        <FocusContext.Provider value={"LanguagePopup"} >
            <div ref={ref} className={`smileySelector pgRatingSelector ${!languageSelector && 'hidden'}`}>
                <p style={{ textAlign: "left", paddingLeft: "5px" }}>
                    <div style={{ position: "absolute", right: "5px", top: "10px", }}>
                        <FocusButtons focusKey='clearPgRatings' bgColor='#e84d31' text='Clear All' onClick={() => { dispatch(setEditedProfile({ ...editedProfile, Language: null })); setLanguageSelector(false); }} />
                        <FocusButtons focusKey='savePgRatings' bgColor='#1da1f2' text='Done' onClick={() => {
                            dispatch(setEditedProfile({ ...editedProfile, Language: editedProfile?.Language }));
                            setLanguageSelector(false);
                        }} />
                    </div>
                    Select Language
                </p>
                {languages.map((language, index) => {
                    let selected = editedProfile?.Language?._id && editedProfile?.Language?._id == language._id;
                    return <ViewingRestrictionItems key={index} index={index} pgRating={language} selected={selected} onClick={() => {
                        if (selected) {
                            dispatch(setEditedProfile({ ...editedProfile, Language: null }));
                        } else {
                            dispatch(setEditedProfile({ ...editedProfile, Language: language }));
                        }
                        focusSelf();
                    }} />;
                })}
            </div>
        </FocusContext.Provider>
    );
}

export default LanguagePopup;
